import {
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

import { BaseModalComponent } from '../_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'simple-confirm-modal',
  templateUrl: 'simple-confirm-modal.component.html',
  styleUrls: ['simple-confirm-modal.component.scss'],
})
export class SimpleConfirmModalComponent extends BaseModalComponent {

  @Input() title: string;

  @Input() note: string;

  @Input() primaryBtnTitle: string;

  @Input() secondaryBtnTitle: string = 'Yes';

  @Input() optionalBtnTitle: string;

  @Input() ghostValue: string = 'confirm-modal';

  @Input() version2: boolean = false;

  @Input() ignoreBackdropClick: boolean = true;

  @Input() data: any;

  @Output() primaryBtnClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() secondaryBtnClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() optionalBtnClick: EventEmitter<any> = new EventEmitter<any>();

  onSecondaryBtnClick() {
    this.hide();
    this.secondaryBtnClick.emit(this.data);
  }

  onPrimaryBtnClick() {
    this.hide();
    this.primaryBtnClick.emit(this.data);
  }

  onOptionalBtnClick() {
    this.hide();
    this.optionalBtnClick.emit(this.data);
  }
}
